import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './permission-dialog.component.html',
    styleUrls: ['./permission-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionDialogComponent {
    today = new Date();
    username = '';
    userSearch = '';
    level = '';
    temporary = false;
    temporaryDate;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PermissionDialogComponent>
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }
}
